const stripTrailingSlash = (value) => value.replace(/\/+$/, '');

const normalizeApiBaseUrl = (url) => {
  if (!url || !url.trim()) {
    return '';
  }

  const sanitizedUrl = stripTrailingSlash(url.trim());

  if (/\/api$/i.test(sanitizedUrl)) {
    if (process.env.NODE_ENV !== 'production') {
      // REACT_APP_API_BASE_URL must be host-only (e.g. https://api.specific-ag.com), not .../api
      console.warn('[api] REACT_APP_API_BASE_URL should not include "/api". It will be normalized automatically.');
    }

    return sanitizedUrl.replace(/\/api$/i, '');
  }

  return sanitizedUrl;
};

const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL);

export const getApiBaseUrl = () => API_BASE_URL;

// Use getApiUrl only for non-axios URL construction (links, downloads, etc).
// Axios requests should pass relative `/api/...` paths and rely on axios.defaults.baseURL.
export const getApiUrl = (path = '') => {
  if (!path) {
    return API_BASE_URL || '';
  }

  if (!API_BASE_URL) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
